/**
 * Component added to fronts that has more than one handle
 */
class MultiHandleComponent {
    constructor(nbrOfHandles) {
        this.typeId = MultiHandleComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
        this.nbrOfHandles = nbrOfHandles;
    }
    eq(other) {
        return this.nbrOfHandles === other.nbrOfHandles;
    }
}
MultiHandleComponent.id = 2060;
export default MultiHandleComponent;
//# sourceMappingURL=MultiHandleComponent.js.map